export const CITY_APPLIED_STORE_FLAG = 'isCityDetect';

export const DEFAULT_CITY_NAME = 'Москва';

export const CITY_CODE_KEY = 'BITRIX_SM_cityCode';
export const CITY_CODE_KEY_CLIENT = 'BITRIX_SM_cityCode-client';
export const CITY_CODE_KEY_UPDATE = 'BITRIX_SM_cityCode-update';

export const CITY_ID_KEY: string = 'cityId';
